import React from 'react';

const Mississippi = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Mississippi Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Seller’s Disclosure Statement: Recommended but not mandatory.</li>
        <li>Attorney Involvement: Common for closing.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Mississippi-Property-Condition-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Disclosure Statement{' '}
          </span>{' '}
          – Sellers must provide details about the property's utilities and
          condition, with buyers having three days to terminate their offer if
          the disclosure comes after an offer is made.
        </li>
      </ol>
    </div>
  );
};

export default Mississippi;
